'use strict'

import axios from 'axios'

const { VUE_APP_CONTENT_URL } = process.env

export default async ({ jwt, categoryId, subCategoryId }) => axios({
  method: 'get',
  headers: {
    Authorization: jwt
  },
  url: `${VUE_APP_CONTENT_URL}/kb/${categoryId}/${subCategoryId}`,
  timeout: 8000
})
